import axios from "axios";

export const fetchPlcLogs = async (machine, take) => {
    const response = await axios.get(`api/plclogs/${machine}?take=${take}`);
    return response.data;
}